var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: "900", "mask-closable": false },
          model: {
            value: _vm.isShow,
            callback: function($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow"
          }
        },
        [
          _vm.agreementType === "VAT"
            ? _c(
                "div",
                { staticClass: "content" },
                [
                  _c("div", { staticClass: "header" }, [
                    _vm._v("创界通平台服务协议-VAT：")
                  ]),
                  _vm._v(" "),
                  _c("UserAgreementVAT")
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "content" },
                [
                  _c("div", { staticClass: "header" }, [
                    _vm._v("创界通平台服务协议-合规认证：")
                  ]),
                  _vm._v(" "),
                  _c("UserAgreementEPR")
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.close(false)
                    }
                  }
                },
                [_vm._v("知道了")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ac28b45", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac28b45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/sureOrder/components/userAgreement29.vue
// module id = null
// module chunks = 